// 基础路径
// const baseURL = 'https://test-all.eebbk.net'
// const baseURL = ' http://assistant-pad-test.eebbk.net'
const baseURL = 'https://genius.eebbk.net'

export default baseURL



// WEBPACK FOOTER //
// ./src/config/baseURL.js